<script>
import { mediaMixin } from '@mixins/media-mixin';
import { authComputed } from '@src/state/helpers';

export default {
  components: {},
  props: {
    platelist: {
      type: Object,
      required: true,
      default: null,
    },
    orgName: {
      type: String,
      required: true,
      default: () => '',
    },
  },
  mixins: [mediaMixin],
  data() {
    return {
      menudPlatelistPlaceholder:
        'https://res.cloudinary.com/menud/image/upload/platelist_default_share_image.jpg',
      placeholder: require('@assets/images/placeholder-photo-upload.svg'),
    };
  },
  computed: {
    ...authComputed,
    coverPhoto() {
      if (
        (this.platelist &&
          !this.platelist.imageurl &&
          !this.platelist.imageUrl) ||
        (this.platelist && this.platelist.imageurl === '') ||
        (this.platelist && this.platelist.imageUrl === '') ||
        (this.platelist &&
          this.platelist.imageurl === this.menudPlatelistPlaceholder) ||
        (this.platelist &&
          this.platelist.imageUrl === this.menudPlatelistPlaceholder)
      ) {
        return this.placeholder;
      } else {
        return this.$_transformCloudinaryImg(
          this.platelist.imageUrl || this.platelist.imageurl
        );
      }
    },
    hasMeals() {
      return this.platelist && this.platelist.mealsInPlatelist > 0;
    },
    mealsInPlatelist() {
      return this.platelist && this.platelist.mealsInPlatelist
        ? this.platelist.mealsInPlatelist
        : 0;
    },
    formattedTitle() {
      const maxCharsLenghtInBox = 17;
      const title = this.platelist.title;
      const shouldTruncate = title.length > maxCharsLenghtInBox;
      return shouldTruncate
        ? this.platelist.title.substr(0, 15) + '...'
        : title;
    },
    isPlatelistLocked() {
      return (
        this.platelist &&
        this.platelist.editabilityStatus &&
        this.platelist.editabilityStatus.locked
      );
    },
  },
  methods: {
    toPlatelistDetail() {
      this.$router
        .push({
          name: 'platelistDetail',
          params: { id: this.platelist.id, platelist: this.platelist },
        })
        .catch(() => {});
    },
  },
};
</script>

<template>
  <div class="card-meal-plan-container">
    <div
      :class="[
        'card-meal-plan-minimal',
        {
          'archived-overlay': platelist.archived,
        },
      ]"
      @click="toPlatelistDetail"
    >
      <div class="card-hero" v-lazy:background-image="coverPhoto">
        <div class="card-meta">
          <div class="card-meta-top">
            <div class="recipe-count"> {{ mealsInPlatelist }} Recipes </div>
            <div
              :class="[
                'meal-plan-status',
                { draft: platelist.draft, archived: platelist.archived },
              ]"
              v-if="platelist.draft || platelist.archived"
            >
              <span v-if="platelist.draft">Draft</span>
              <span v-if="platelist.archived">Archived</span>
            </div>
          </div>
          <div class="meal-plan-flagged" v-if="platelist.flagged">
            Flagged
          </div>
        </div>
      </div>
      <div class="card-content">
        <h3>{{ formattedTitle }}</h3>
        <span class="card-meta">
          by {{ isPlatelistLocked ? orgName : trainerFullName }}
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card-meal-plan-container {
  background-color: white;
  border: 10px solid white;
  border-radius: $base-border-radius-md;
  position: relative;
  transition: transform $duration-animation-base - 75 ease-in-out,
    box-shadow $duration-animation-base - 50 ease-in-out;

  &:hover {
    box-shadow: 0 0.4rem 0.8rem rgba($color-black-wo-rgb, 0.1);
    cursor: pointer;
    transform: scale(1.01);
  }
}

.card-meal-plan-minimal {
  &.archived-overlay {
    .meal-plan-status {
      position: relative;
      z-index: 1;
    }

    &::after {
      background: rgba($color-white-wo-rgb, 0.5);
      border-radius: $base-border-radius-md;
      bottom: 0;
      content: '';
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .card-hero {
    align-items: flex-start;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: $base-border-radius-md;
    display: flex;
    height: 20rem;
    margin-bottom: 1.3rem;
    width: 100%;

    .card-hero-checkbox {
      left: 1.3rem;
      position: relative;
      top: 1.3rem;
    }

    .card-meta {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
      padding: 1rem;
      width: 100%;

      .card-meta-top {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }

      .recipe-count,
      .meal-plan-status,
      .meal-plan-flagged {
        align-items: center;
        border-radius: 0.5rem;
        color: white;
        display: flex;
        font-size: 1.2rem;
        font-weight: 800;
        height: 2.5rem;
        letter-spacing: 0.1px;
        line-height: 1.6rem;
        padding: 0.3rem 0.9rem;
        text-transform: uppercase;
      }

      .recipe-count {
        background: $color-card-program-meta-bg;
        mix-blend-mode: normal;
        opacity: 0.7;
        width: 9.7rem;
      }

      .meal-plan-status {
        &.draft {
          background-color: $color-action;
        }

        &.archived {
          background-color: black;
        }
      }

      .meal-plan-flagged {
        background-color: $color-red;
        display: flex;
        justify-content: center;
      }
    }
  }

  .card-content {
    .card-title {
      color: $color-heading-text;
      font-size: 2.1rem;
      font-style: normal;
      font-weight: 900;
      letter-spacing: -0.3px;
      line-height: 2.4rem;
    }

    .card-meta {
      text-transform: uppercase;
    }
  }
}
</style>
